import { useAppDispatch, useAppSelector } from '../../../../../../../../shared/libs/redux';
import { useBindTemplateTag } from '../../../../../../../../features/template/tag/bind/api/useBindTemplateTag';
import {
	useCreateTemplateTag,
} from '../../../../../../features/templateGroupTag/groupTagsDropdown/services/create-tag/useCreateTemplateTag';
import {
	setCurrentTemplateTagsIds
} from '../../../../../../../../entities/template/private-template/model/privateTemplateSlice';

/**
 * Хук для создания нового тега и его привязки к шаблону.
 * Объединяет `useCreateTemplateTag` и `useBindTemplateTag`.
 */
export const useTemplateTagActions = (
	templateId: string,
	type: 'TEAM_TEMPLATE' | 'PRIVATE_TEMPLATE',
) => {
	const dispatch = useAppDispatch();

	const { onCreateTag } = useCreateTemplateTag();
	const bindTag = useBindTemplateTag(type, templateId);

	const selectedTags = useAppSelector(
		(state) => state.privateTemplate.currentTemplateTagsIds,
	);

	const bindCreatedTag = async (name: string) => {
		const res = await onCreateTag(name);
		if (res) {
			await bindTag(res);
			dispatch(setCurrentTemplateTagsIds([...selectedTags, res.id]));
		}
	};

	return { bindCreatedTag };
};
